<template>
  <el-dialog
    title="导入线索"
    :visible.sync="dialogVisible"
    width="50%"
    class="importClueDialog"
    @close="dialogCloseHandle"
  >
    <div class="box">
      <div>
        <div class="indexFlag">一、</div>
        <div class="wrapper">
          <div class="label">请按照线索模板的格式准备要导入的数据<span @click="templateDownload">下载线索导入模板</span></div>
          <div class="content special">
            注意事项:
            <p>1. 模板中的表头名称不可更改，表头行不能删除；</p>
            <p>2. 其中表头中红色项为必填项，非必填项不可删除，无内容空置即可；</p>
            <p>3. 导入文件请勿超过1MB。</p>
          </div>
        </div>
      </div>
      <!--      <div>-->
      <!--        <div class="indexFlag">二、</div>-->
      <!--        <div class="wrapper">-->
      <!--          <div class="label">数据重复时操作</div>-->
      <!--          <div class="content">-->
      <!--            <el-radio-group v-model="radio">-->
      <!--              <el-radio :label="3">不覆盖</el-radio>-->
      <!--              <el-radio :label="6">覆盖</el-radio>-->
      <!--            </el-radio-group>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div>
        <div class="indexFlag">二、</div>
        <div class="wrapper">
          <div class="label">请选择需要导入的文件</div>
          <div class="content">
            <el-upload
              ref="importClue"
              class="upload-demo"
              :action="baseUrl"
              :headers="uploadheaders"
              :with-credentials="true"
              :on-remove="beforeRemove"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :data="uploadData"
              multiple
              :limit="1"
              :file-list="fileList"
              :auto-upload="false"
            >
              <el-button size="small" type="primary" :disabled="fileList.length > 1">选择文件</el-button>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <button class="common_button_white" @click="dialogCloseHandle">取消</button>
      <button class="common_button" @click="submitHandlen">确定</button>
    </div>
  </el-dialog>
</template>

<script>
import { cluePoolListApi } from '../../service';
import requestBaseUrl from '@/API/request/baseUrl';
import {  getTicket } from '@/utils/utils';
export default {
  data () {
    return {
      dialogVisible: false,
      radio: 3,
      fileList: [],
      uploadheaders: {
        sysId: window._env_.VUE_APP_SYSID,
        union_session_ticket:getTicket()
      },
      baseUrl: `${requestBaseUrl}/lead/excel/excelImport`,
      uploadData: {}
    };
  },
  props: {
    importClueShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    importClueShow (val) {
      if (val) {

      } else {
        this.fileList = [];
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    templateDownload () {
      cluePoolListApi.templateDownload().then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    submitHandlen () {
      this.$refs.importClue.submit();
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    beforeUpload (file) {
      let fileSize = file.size / 1024 / 1024 < 10;
      if (!fileSize) {
        this.$message.error('上传的文件大小不能超过10M');
      }
      return fileSize;
    },
    handleSuccess (response, file, fileList) {
      if (response.status === '200') {
        this.$emit('submitHandle');
        this.$message.success('导入成功');
      } else {
        this.$message.error(response.err);
      }
    },
    beforeRemove (file, fileList) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.importClueDialog{
  .box{
    >div{
      >.indexFlag{
        float: left;
      }
      >.wrapper{
        float: left;
        >.label>span{
          color: #3384FE;
          cursor: pointer;
          padding-left: 10px;
        }
        >.special{
          color: #909399;
        }
        >.content{
          padding: 16px 0;
          >p:first-child{
            margin-top: 2px;
          }
          >p{
            padding-left: 20px;
            line-height: 24px;
          }
        }
      }
      &:after{
        content: '';
        display: block;
        clear: both;
      }
    }
  }
}
</style>
